export default __webpack_public_path__ + "static/media/ISEO CLASS 9 SYLLABUS.44f545da.pdf";